export default __webpack_public_path__ + "static/media/ukbic.90f74ca0.png";